import newYearBannerCenter from 'assets/newYearBannerCenter.png';
import newYearBannerLeft from 'assets/newYearBannerLeft.png';
import newYearBannerLeftSecond from 'assets/newYearBannerLeftSecond.png';
import newYearBannerRight from 'assets/newYearBannerRight.png';
import styled from 'styled-components';

import { PromotionBannerProps } from '../types';

export const NewYearBanner: React.FC<PromotionBannerProps> = ({ onClick, mode }) => {
  return (
    <Banner onClick={onClick}>
      <CommonContainer>
        <LeftContainer>
          <LeftSidePicture />
          <LeftSidePictureSecond />
        </LeftContainer>
        <CenterContainer>
          <LeftCenter />
          <CenterText>
            <UpperText>SAVE 55%</UpperText>
            <LowerText>WITH YEARLY PLAN</LowerText>
          </CenterText>
          <RightCenter />
        </CenterContainer>
        <RightContainer>
          <RightSidePicture />
        </RightContainer>
      </CommonContainer>
    </Banner>
  );
};

const Banner = styled.div<React.PropsWithChildren<{ onClick: () => void }>>`
  height: 60px;
  width: 100%;
  position: fixed;
  background: black;
  z-index: 100;
  cursor: pointer;
`;

const CommonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 470px) {
    position: relative;
    width: 150px;
    left: -20px;
    margin: 0;
  }
`;

const LeftSidePicture = styled.div`
  height: 60px;
  width: 194px;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-image: url(${newYearBannerLeft});
  background-repeat: no-repeat;

  @media (max-width: 470px) {
    width: 100px;
  }
`;

const LeftSidePictureSecond = styled.div`
  height: 32px;
  width: 80px;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-image: url(${newYearBannerLeftSecond});
  background-repeat: no-repeat;

  @media (max-width: 470px) {
    display: none;
  }
`;

const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 225px;

  @media (max-width: 470px) {
    width: 100px;
    position: relative;
    left: -30px;
    margin: 0;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const LeftCenter = styled.div`
  height: 46px;
  width: 26px;
  background-size: cover;
  background-position: center;
  background-image: url(${newYearBannerCenter});
  background-repeat: no-repeat;

  @media (max-width: 1000px) {
    display: none;
  }
`;

const CenterText = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px;

  @media (max-width: 470px) {
    margin: 0;
  }
`;

const UpperText = styled.p`
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  text-align: left;
  color: #ffffff;
`;

const LowerText = styled.p`
  font-size: 12px;
  font-weight: 700;
  line-height: 16.37px;
  text-align: left;
  color: #ffffff;

  @media (max-width: 470px) {
    font-size: 10px;
    text-transform: uppercase;
  }
`;

const RightCenter = styled.div`
  height: 46px;
  width: 26px;
  background-size: cover;
  background-position: center;
  background-image: url(${newYearBannerCenter});
  transform: scaleX(-1);
  background-repeat: no-repeat;

  @media (max-width: 1000px) {
    display: none;
  }
`;

const RightSidePicture = styled.div`
  height: 60px;
  width: 190px;
  background-size: cover;
  background-position: center;
  background-image: url(${newYearBannerRight});
  background-repeat: no-repeat;

  @media (max-width: 1000px) {
    // display: none;
  }
`;